import PlacardImg from '../../Assets/images/AboutUs/placardImg.png';
import Placard2Img from '../../Assets/images/AboutUs/placard2Img.jpg';
import Placard3Img from '../../Assets/images/AboutUs/placard3Img.jpg';
import Placard4Img from '../../Assets/images/AboutUs/placard4Img.jpg';
import { globalVal } from '../globalvalues';
export const aboutUsPage: any = {
    topHeading: `We are a socially-conscious mobile service
                  making everyday connectivity more meaningful`,

    missionTitle: `We have two missions:`,

    mission1: {
        text: `Doing right by our customers`,
        subText: `We offer mobile plans on the most reliable network, delivered with care and
        commonsense`,
    },
    mission2: {
        text: `Doing right by our world`,
        subText: `Every plan helps give a plan to a woman in need, so we can share the benefits of
        digital connectivity`,
    },
    letterTitle: 'A letter from our CEO',

    ceoLetter: `<span>Having worked in the mobile industry for many years, we saw lots of things that we would do differently.</span> So we posed the question: what kind of mobile service would we love?
    <span>The answer was a simple, digital experience with a human touch. No contracts, no fine print, and commonsense policies. Once we established that as the basis of our company, we attached a big dream to it. In the 21st century, connectivity and internet access is as basic as the freedom of speech,
    but 3.9 billion people are missing out. So despite our size, we set out to make a meaningful impact and help give those in need a digital voice.<br><br>
    
    If you can get the best network at a better price, and make a difference – why not?<br><br></span>
    
    Happy connecting!`,

    ceoName: `Harjot Saluja,<span>&nbspCEO</span>`,
    meetTitle: 'Meet the Team',
    meetText: `With headquarters in the U.S. and an office in Bangalore, India,
    our mission to help connect the world is delivered by a truly
    global team.  We love all things tech, subsist on coffee, and show
    our competitive sides around the pool table.`,

    placards: [
        {
            text: `When we started off at ${globalVal &&
                globalVal.long_name}, we committed to each other that we will be honest to our customers, to each other as a team, and to the business. Key connection between customers and business goals, is the TEAM. I am so fortunate to be in the company of such world class, passionate and dedicated professionals at ${globalVal &&
                globalVal.short_name}! Our dream will come true…”`,
            subText: `Harsh Saxena, <span>Chief Operating Officer</span>`,
            image: PlacardImg,
        },
        {
            text: `I'm grateful to work with our nonprofit partners and meet the women who have received Gigs that Give connectivity. It was amazing to know that my tiny contribution could make such a difference.`,
            subText: `Priya Veembur, <span>Content Writer</span>`,
            image: Placard2Img,
        },
        {
            text: `Our team is responsible for creating a world-class platform and digital experience for the customer. It's challenging, but also fun to be innovating on a daily basis.`,
            subText: `Avi Chopra, <span>Engineering Head</span>`,
            image: Placard3Img,
        },
        {
            text: `I love the collaborative approach we take to delivering the best for our customers. Not many CEOs are willing to jump in on customer support chats, but ours is.`,
            subText: `Jules Pearson, <span>Head of Customer Success</span>`,
            image: Placard4Img,
        },
    ],
    commitedTitle: `${globalVal && globalVal.short_name} 10- Committed to awesome`,
    commitedText: `When we created the ${globalVal && globalVal.short_name} brand, we set out to build a
    company that is committed to 10 primary values that we feel
    everyone – including businesses – should live by.`,
    commitedToAwesomeText: [
        {
            label: 'first',
            box1: {
                title: 'Customer',
                subtext: 'Treat our customers the way we want to be treated.',
            },
            box2: {
                title: 'Impact',
                subtext: 'Take pride in every unconnected person we connect – it’s making a difference.',
            },
            box3: {
                title: 'Transparency',
                subtext: 'Don’t make your customer interpret what you’re saying… ever.',
            },
            box4: {
                title: 'Trust',
                subtext: 'Earn our customers’ trust in every interaction let’s wow them with how much we care.',
            },
            box5: {
                title: 'Simplicity',
                subtext: "Getting mobile service doesn't have to be so complicated.",
            },
        },
        {
            label: 'second',
            box1: {
                title: 'The Bar',
                subtext: 'We have high product standards.',
            },
            box2: {
                title: 'Innovation',
                subtext: "We'll keep coming up with cool products and services.",
            },
            box3: {
                title: 'Culture',
                subtext: 'The people responsible for your mobile service actually like working here.',
            },
            box4: {
                title: 'Reliable',
                subtext: "You'll get the best network quality, speeds, and reliability… no compromises.",
            },
            box5: {
                title: 'Fiscally Responsible',
                subtext:
                    "We're a for-profit company that makes it a priority to help others… we make a little less profit, and we're okay with that.",
            },
        },
    ],
};
